import React, { useState, useEffect } from "react";
import "./SportClasses.css";
import { Link, useNavigate } from "react-router-dom";
import { MdArrowForwardIos } from "react-icons/md";
import BackBtn from "../../Components/BackBtn/BackBtn";
import Help from "../../Components/Help/Help";
import sportClassesFAQ from "./sportClassesFAQ";
import sportClassesHelp from "./sportClassesHelp";
import SportClassesBanners from "./SportClassesBanners";
import FAQ from "../../Components/FAQ/FAQ";
import { useAuth } from "../../AuthContext";
import Axios from "axios";
import Alert from "../../Components/Alert/Alert";
import Loading from "../../Components/Loading/Loading";
import { useBaseUrl } from "../../ApiContext";

export default function SportClasses() {
  const navigate = useNavigate();
  const baseUrl = useBaseUrl()
  const { userToken } = useAuth();
  const [showQuestionModal, setShowQuestionModal] = useState(false);
  const [availablePlans, setAvailablePlans] = useState({});
  const [showAlert, setShowAlert] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const showModalHandler = () => {
    setShowQuestionModal(true);
  };

  const handleClose = () => {
    setShowQuestionModal(false);
  };

  const handleExerciseLink = (label, title) => {
    if (availablePlans[label].available) {
      navigate("/exercise", { state: { label: label, title: title } });
    }
  };

  useEffect(() => {
    const fetchAvailablePlans = async () => {
      try {
        const response = await Axios.get(
          `${baseUrl}/exercise_plan_availability`,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        setAvailablePlans(response.data);
        setIsLoading(false);
      } catch (error) {
        console.log("Error during getting available exercise plans", error);
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 2000);
      }
    };
    if (userToken) {
      fetchAvailablePlans();
    }
  }, [baseUrl, userToken]);

  return (
    <div className="gymBg bgContainer">
      <div className="blurOverlay">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
            <BackBtn />
            <Help
              showQuestionModal={showQuestionModal}
              onShow={showModalHandler}
              onHide={handleClose}
              data={sportClassesHelp}
            />
          </div>
          <div className="pageTitle horizontalBorder">تناسب اندام</div>
          {isLoading ? (
            <Loading />
          ) : (
            <>
              <div className="sportClassesContainer scroll centeredFlex">
                <div className="sportClassesContent  horizontalBorder responsiveWidth">
                  {SportClassesBanners.map((item) => {
                    const isAvailable =
                      availablePlans[item.label] &&
                      availablePlans[item.label].available;
                    return (
                      <div
                        key={item.id}
                        onClick={() =>
                          handleExerciseLink(item.label, item.title)
                        }
                        className={`sportClass ${item.label}Banner centeredFlex`}
                      >
                        {isAvailable ? (
                          <div className="singUpClass">
                            <MdArrowForwardIos className="singUpClassIcon" />
                            ثبت نام
                          </div>
                        ) : (
                          <img
                            src="/images/lock.svg"
                            className="sportClassLockIcon"
                            alt="lock"
                          />
                        )}
                        <p>{item.title}</p>
                        <img
                          src={item.img}
                          alt="exercise"
                          className="sportClassImg"
                        />
                      </div>
                    );
                  })}
                  <Link
                    to="/selfCoaching"
                    className="sportClass beYourOwnCoach link centeredFlex"
                  >
                    <p className="hiddenText">شروع کن</p>
                    <p>مربی خودت باش</p>
                    <img
                      src="/images/whiteLogo.svg"
                      alt="logo"
                      className="sportClassImg"
                    />
                  </Link>
                </div>
          <div className="sportClassesFaq responsiveWidth">
            <FAQ
              question={sportClassesFAQ[0].question}
              answer={sportClassesFAQ[0].answer}
            />
          </div>
              </div>
            </>
          )}
          <Alert showAlert={showAlert} alertText="خطا در برقراری ارتباط" />
        </div>
      </div>
    </div>
  );
}
